import { STATIC_EVENTOS, DEFAULT_IMG_SIZE } from "@/config/setup";
function isUrl(string) {
  try {
      new URL(string);
      return true;
  } catch (error) {
      return false;
  }
}

export const globales = {
  computed: {
    cookieLocale() {
      return this.$cookie.get("lang");
    },
    layoutSecciones() {
      // console.log('aqui', this.$store.state.layout)
      return this.$store.state.layout.secciones;
    },
    entradasUrl() {
      const lang = this.$i18n.locale;
      const Url = `https://portal.kutxabank.es/cs/Satellite?pagename=PortalKutxabank/Page/PK_BuscadorRecogidaEntradas&hizkuntza=${lang}&kutxabank=si`;
      return Url;
    },
    Hoy() {
      const Hoy = this.$store.state.Hoy;
      const fechaActual = {};
      const mes = Hoy.getMonth() + 1;
      const dia = Hoy.getDate();

      if (Hoy) {
        fechaActual.year = Hoy.getFullYear();
        fechaActual.mes = ("0" + mes).slice(-2);
        fechaActual.dia = ("0" + dia).slice(-2);
        fechaActual.hora = ("0" + Hoy.getHours()).slice(-2);
        fechaActual.minutos = ("0" + Hoy.getMinutes()).slice(-2);
        fechaActual.segundos = ("0" + Hoy.getSeconds()).slice(-2);
        fechaActual.ahora =
          fechaActual.year +
          fechaActual.mes +
          fechaActual.dia +
          fechaActual.hora +
          fechaActual.minutos +
          fechaActual.segundos;
      }

      return fechaActual;
    },
    menuMovil: {
      get() {
        return this.$store.state.menuMovil;
      },
      set(valor) {
        this.$store.commit("setMenuMovil", valor);
      },
    },
    cargando: {
      get() {
        return this.$store.state.cargando;
      },
      set(valor) {
        this.$store.commit("setCargando", valor);
      },
    },
    detalleEvento() {
      return this.$store.state.detalleEvento;
    },
    eventosWeb() {
      return this.$store.state.eventosWeb;
    },
    eventoBuscador: {
      get() {
        return this.$store.state.eventoBuscador;
      },
      set(valor) {
        this.$store.commit("setEventoBuscador", valor);
      },
    },
    enlacesCabecera() {
      const menu = this.seccionMenu;
      return menu.filter(elemento => elemento.tipo == "enlace");
    },
    menuCabecera() {
      const elementosMenu = this.seccionMenu.filter(m => m.tipo != "enlace");
      // console.log('MENUUU ', elementosMenu)
      return elementosMenu.map(m => {
        const elementoMenu = {};
        elementoMenu.texto = m.nombre;
        elementoMenu.orden = m.orden;
        elementoMenu.id = m.id;

        switch (m.tipo) {
          case "home":
            elementoMenu.to = "/";
            break;

          case "filtro":
            // const to = { name: m.id, params: { pagina: m.elemento }}
            elementoMenu.to = "/" + m.id;
            elementoMenu.filtro = m.elemento;

            break;

          case "enlace":
            elementoMenu.to = m.url;
            break;

          default:
            break;
        }

        return elementoMenu;
      });
    },
  },
  data() {
    return {
      // https://ticket.kutxabank.es/j4pro/public/janto/main.php?Nivel=Sesiones&Idioma=ES&idRecinto=IGELDO&idEvento=DONOSTFESTIB19&instala=KB
      // iframeBaseUrl: "https://ticket.kutxabank.es/j4pro/public/janto/main.php?Nivel=Sesiones",
      ruta_static: STATIC_EVENTOS,
      getIframeBaseUrl(contexto) {
        if (contexto === "Janto_UNI") {
          return "https://tickets.janto.es/cajasuriframe/public/janto/main.php?Nivel=Sesiones";
        }

        return "https://iframekb.janto.es/public/janto/main.php?Nivel=Sesiones";
      },
      colorDestacado: "#E42228",
      defaultImageSize: DEFAULT_IMG_SIZE,
      top5Color: "#FFD300",
      ratios: {
        fondo: 2.6,
        poster: 0.67,
        destacados: 1.74,
        banner: 1.33,
        vertical: 0.83,
        cuadrado: 1,
      },
      tipoTransicion: "fade",
      eventoActual: null,
      windowSize: {
        x: 0,
        y: 0,
      },
      consultasEntradas: [
        {
          nombre: "Consulte sus entradas",
          tipo: "pagina",
          elemento: "",
          url: "/entradas",
          orden: 0,
          id: "entradas",
        },
        {
          nombre: "Recogida de entradas",
          tipo: "enlace",
          elemento: "",
          url:
            "https://portal.kutxabank.es/cs/Satellite?pagename=PortalKutxabank/Page/PK_BuscadorRecogidaEntradas&hizkuntza=es&kutxabank=si",
          orden: 0,
          id: "recogida",
        },
        {
          nombre: "Cómo comprar",
          tipo: "pagina",
          elemento: "",
          url: "/como-comprar",
          orden: 2,
          id: "comprar-como",
        },
      ],
      recintos: [
        {
          nombre: "Araba",
          tipo: "filtro",
          elemento: "01",
          orden: 0,
          id: "araba",
        },
        {
          nombre: "Bizkaia",
          tipo: "filtro",
          elemento: "48",
          orden: 0,
          id: "bizkaia",
        },
        {
          nombre: "Gipuzkoa",
          tipo: "filtro",
          elemento: "20",
          orden: 0,
          id: "gipuzkoa",
        },
        {
          nombre: "Córdoba",
          tipo: "filtro",
          elemento: "00",
          orden: 0,
          id: "cordoba",
        },
        {
          nombre: "Otros",
          tipo: "filtro",
          elemento: "00",
          orden: 0,
          id: "otros",
        },
      ],
      provincias: [
        {
          nombre: "Araba",
          tipo: "filtro",
          elemento: "22",
          orden: 0,
          id: "araba",
        },
        {
          nombre: "Bizkaia",
          tipo: "filtro",
          elemento: "11",
          orden: 0,
          id: "bizkaia",
        },
        {
          nombre: "Gipuzkoa",
          tipo: "filtro",
          elemento: "13",
          orden: 0,
          id: "gipuzkoa",
        },
        {
          nombre: "Otros",
          tipo: "filtro",
          elemento: "00",
          orden: 0,
          id: "otros",
        },
      ],
      categorias: [
        { nombre: "Cine", tipo: "filtro", elemento: "1", orden: 0, id: "cine" },
        {
          nombre: "Clásica",
          tipo: "filtro",
          elemento: "5",
          orden: 1,
          id: "clasico",
        },
        {
          nombre: "Culinary Zinema",
          tipo: "filtro",
          elemento: "48",
          orden: 9,
          codigo: "48",
          id: "culinary-zinema",
        },
        {
          nombre: "Danza",
          tipo: "filtro",
          elemento: "16",
          orden: 2,
          id: "danza",
        },
        {
          nombre: "Deportes",
          tipo: "filtro",
          elemento: "3",
          orden: 3,
          id: "deportes",
        },
        {
          nombre: "Exposiciones",
          tipo: "filtro",
          elemento: "13",
          orden: 4,
          id: "exposiciones",
        },
        {
          nombre: "Festivales",
          tipo: "filtro",
          elemento: "7",
          orden: 5,
          id: "festival",
        },
        {
          nombre: "Infantil",
          tipo: "filtro",
          elemento: "4",
          orden: 6,
          id: "infantil",
        },
        {
          nombre: "Música",
          tipo: "filtro",
          elemento: "6",
          orden: 7,
          id: "musica",
        },
        {
          nombre: "Teatro",
          tipo: "filtro",
          elemento: "2",
          orden: 8,
          id: "teatro",
        },
        {
          nombre: "Varios",
          tipo: "filtro",
          elemento: "8",
          orden: 20,
          id: "varios",
        },
      ],
      seccionMenu: [
        { nombre: "Inicio", tipo: "home", elemento: "", orden: 0, id: "home" },
        {
          nombre: "Categorías",
          tipo: "filtro",
          elemento: "",
          orden: 1,
          id: "eventos",
        },
        {
          nombre: "Consultas de Entradas",
          tipo: "filtro",
          elemento: "15",
          orden: 2,
          id: "conciertos",
        },
        {
          nombre: "Eventos",
          tipo: "filtro",
          elemento: "20",
          orden: 3,
          id: "musicales",
        },
        // {nombre: 'Teatro', tipo: 'filtro', elemento:'2', orden:4, id:"teatro"},
        {
          nombre: "Recintos",
          tipo: "enlace",
          elemento: "",
          url: "recintos",
          orden: 5,
          id: "recintos",
        },
        // {nombre: 'Mis Operaciones', tipo: 'enlace', elemento:'', url:'mis-operaciones', orden:6, id:"misoperaciones"}
      ],
      sinImagen:
        "https://firebasestorage.googleapis.com/v0/b/cmsfrontend-d17fc.appspot.com/o/000utils%2Fdefault-kutxabank.png?alt=media&token=54e18b58-74ad-4d06-b774-7c11c8f6a94b",
      idiomas: ["eu", "es", "en"],
    };
  },
  methods: {
    webItem(id) {
      if (!id) {
        return;
      }

      return this.$store.state.itemsWeb.find(item => item.id === id);
    },
    miImagen(evento, tipo = DEFAULT_IMG_SIZE) {
      const existeWebitem = this.webItem(evento.webId);
      const sinImagen =
        "https://firebasestorage.googleapis.com/v0/b/cmsfrontend-d17fc.appspot.com/o/000utils%2Fdefault-kutxabank.png?alt=media&token=54e18b58-74ad-4d06-b774-7c11c8f6a94b";
      const contexto = evento.cmsID ? evento.cmsID.split("@")[1] : null;

      if (existeWebitem && existeWebitem[tipo]) {
        return existeWebitem[tipo];
      } else if (evento.cms && evento.cms[tipo]) {
        return evento.cms[tipo];
      } else if (contexto && evento.UrlCartel) {
        return isUrl(evento.UrlCartel) ? evento.UrlCartel : STATIC_EVENTOS[contexto] + evento.UrlCartel;
      } else {
        return sinImagen;
      }
    },
    setLocale(lang) {
      const idioma = this.idiomas.find(locale => locale == lang);
      if (idioma) {
        this.$cookie.set("lang", lang, { expires: 7 });
        this.$i18n.locale = lang;
        const parametros = this.$route.params;
        parametros.lang = lang;
        const ruta = this.$route.name;

        this.$router.replace({ params: parametros });
        // console.log('ruta', this.$route, parametros)
        // -- console.log('lang', lang)
      }
    },
    buscadorEventos(id) {
      console.log("buscador de eventos", id);

      // const evento = this.eventosWeb.find(e => e.idRegistro == idRegistro);
      const evento = this.$store.state.eventosJanto[id];
      if (evento) {
        const cmsID = evento.cmsID;
        const recinto = evento.Recinto[0].Id;
        this.$store.commit("setEventoBuscador", "");
        // console.log('cmsID eventos', cmsID, 'recinto', recinto)

        this.$router.push({
          path: `/${this.$i18n.locale}/detalle/${cmsID}/${recinto}`,
        });
      }
      // console.log('buscador de eventos', idRegistro)
    },
    getFecha(evento, verHora) {
      // console.log('getFecha hora', verHora)
      var resultado = null;
      const hoy = this.Hoy;
      function fechaInicio(fecha) {
        const year = fecha.substr(0, 4);
        const mes = fecha.substr(4, 2);
        let dia = fecha.substr(6, 2);

        if (year == hoy.year && mes == hoy.mes && dia < hoy.dia) {
          dia = hoy.dia;
        }

        return dia + "/" + mes;
      }

      function fechaFin(fecha) {
        const year = fecha.substr(0, 4);
        const mes = fecha.substr(4, 2);
        const dia = fecha.substr(6, 2);

        if (year <= hoy.year && mes <= hoy.mes && dia < hoy.dia) {
          return "pasado";
        } else {
          return dia + "/" + mes;
        }
      }

      const inicio = fechaInicio(evento.FSesionMin);
      const fin = fechaFin(evento.FSesionMax);

      if (!verHora) {
        resultado = " " + fin;
      } else if (inicio == fin) {
        resultado =
          "El " +
          fin +
          " a las " +
          evento.FSesionMin.substr(8, 2) +
          ":" +
          evento.FSesionMin.substr(10, 2) +
          "h";
      } else if (fin) {
        resultado = inicio + " - " + fin;
      } else {
        resultado = null;
      }

      // console.log('fechas', resultado, hoy, inicio, fin)

      return resultado;
    },
  },
};
